import {useEffect, useRef, useState} from 'react';
import {wdiCore, WdiInput, WdiModalAppProps} from '@/components/WdiControls';
import {ProFormInstance} from '@ant-design/pro-form';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ResponseStatus} from '@/utils/request';
import {WdiTable} from '@/components/WdiControls/WdiTable';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {FormSaMktAllocateMonth} from '@/services/mkt/sa';
import DataStore from '@/components/GridWidget/DataStore';
import {message} from 'antd';
import moment from 'moment';
import {addAllocateAmount} from '@/pages/mkt/sa/components/data';


const FormSaMktDetailAllocateMonthEditApp: React.FC<WdiModalAppProps> = (props) => {

  const formRef = useRef<ProFormInstance>();
  const {dataSource, activityStartDate, activityEndDate, detailDataSource} = props.data;
  const [initDataSource, setInitDataSource] = useState<any[]>([]);

  const columns = [
    {
      title: '年月',
      key: 'ym',
      dataIndex: 'ym',
      width: 90,
    },
    {
      title: '分摊比例',
      key: 'shareRate',
      dataIndex: 'shareRate',
      width: 210,
      render: (text: any, row: any, index: any) => {
        return <WdiInputNumber format='p' digits={4} min={0} value={row.shareRate} onBlur={(e: any) => {
          const {...newRow} = row;
          newRow.shareRate = wdiCore.Number.AmountToString(e.target.value / 100, 6);
          setInitDataSource(DataStore.edit(initDataSource, newRow));
        }}/>;
      },
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark',
      width: 300,
      render: (text: any, row: any, index: any) => {
        return <WdiInput defaultValue={text}
                         onBlur={(e: any) => {
                           const {...newRow} = row;
                           newRow.remark = e.target.value;
                           setInitDataSource(DataStore.edit(initDataSource, newRow));
                         }}
        />;
      },
    }
  ];

  useEffect(() => {
    if (activityStartDate && activityEndDate) {
      const activityStartDateStr = moment(activityStartDate).format('YYYY-MM-DD');
      const activityEndDateStr = moment(activityEndDate).format('YYYY-MM-DD');

      FormSaMktAllocateMonth.init({
        startDate: activityStartDateStr,
        endDate: activityEndDateStr,
        allMonthRemark: dataSource
      }).then(response => {
        if (response.data && response.data.length > 0) {
          const newInitDataSource = addAllocateAmount(response.data, detailDataSource, 'shareRate');
          if (dataSource && dataSource.length > 0) {
            newInitDataSource.forEach(item => {
              const record = dataSource.find((data: any) => data.ym == item.ym);
              if (record) {
                item.shareRate = record.shareRate;
              }
            });
          }
          setInitDataSource(DataStore.init(newInitDataSource));
        }
      });
    }
  }, [activityStartDate, activityEndDate]);

  return (
    <WdiModalForm
      formRef={formRef}
      {...HorzLayoutOpts}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => props.onClose?.(),
        okText: '保存',
      }}
      onFinish={async () => {
        if (!initDataSource || initDataSource.length == 0) {
          message.error('明细行数必须大于0');
          return;
        }
        let validate = false;
        let details = [...initDataSource];
        initDataSource.forEach(item => {
          if (wdiCore.Object.IsNullOrUndefined(item.amountMonth)) {
            validate = true;
            return false;
          }
          return true;
        });
        if (validate) {
          message.error('分摊比例不能为空');
          return;
        }

        const validateShareRate = (details: any[]) => {
          let totalShareRate = 0;
          for (const item of details) {
            const shareRate = wdiCore.Number.ToNumber(item.shareRate, 6) || 0;
            totalShareRate = wdiCore.Number.ToNumber(totalShareRate + shareRate, 6)

            if (totalShareRate > 1) {
              return false;
            }
          }
          return Math.abs(totalShareRate - 1) < Number.EPSILON;
        };

        if (!validateShareRate(details)) {
          message.error('分摊比例之和必须为100%!');
          return;
        }
        details.forEach(item => {
          item.shareRate = wdiCore.Number.ToNumber(item?.shareRate);
        })
        props.onSave?.({code: ResponseStatus.SUCCESS, data: initDataSource});
      }}

    >
      <WdiTable
        pagination={false}
        columns={columns}
        dataSource={initDataSource}
        aggrColumns={['shareRate']}
        showAggrType={'p'}
        digits={4}
      />
    </WdiModalForm>
  );
};
export default FormSaMktDetailAllocateMonthEditApp;
